import { DeleteOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import { Tooltip, Button, Modal, message } from "antd";
import { COMMUNICATION_TASK_STATUS } from "common/constants";
import { useBulkCancelCommunicationTasksMutation } from "features/communicationTasks/communicationTasksAPI";
import { PERMISSIONS } from "features/permissions";
import useAuthorizations from "features/permissions/hooks/useAuthorizations";

const { confirm } = Modal;

export function CommunicationTasksBulkActions({ dataSource = [] }) {
  const [deleteCommunicationTasks] = useBulkCancelCommunicationTasksMutation();

  const {
    data: { [PERMISSIONS.COMMUNICATION__DELETE]: isCommunicationTaskDeleteAuthorized },
  } = useAuthorizations();

  const actionItems = [
    {
      key: "delete",
      label: "Delete Scheduled Communication",
      icon: <DeleteOutlined />,
      actionHandler: deleteCommunicationTasks,
      isVisible: isCommunicationTaskDeleteAuthorized,
      disabled:
        dataSource.length === 0 ||
        // Only show the option if the selected communication tasks are scheduled
        // (not already cancelled, succeeded, or failed) (item.status = COMMUNICATION_TASK_STATUS.SCHEDULED)
        dataSource.some((item) => item.status !== COMMUNICATION_TASK_STATUS.SCHEDULED),
    },
  ];

  const handleOk = (item, key) => {
    confirm({
      title: `Are you sure you want to ${key} these communication tasks?`,
      icon: <ExclamationCircleOutlined />,
      async onOk() {
        const result = await item.actionHandler({
          communicationTaskIds: [...dataSource.map((row) => row.id)],
        });

        if ("error" in result) {
          message.error(`Failed to ${key} communication tasks`);
        }

        if ("data" in result) {
          switch (key) {
            case "delete":
              message.success("Communication tasks successfully deleted");
              break;
            default:
              message.success(`Communication tasks successfully ${key}ed`);
          }
        }
      },
    });
  };

  const handleMenuClick = ({ item, key, keyPath, domEvent }) => {
    // This prevents navigation to invoice detail when clicking on a dropdown item
    domEvent.preventDefault();
    domEvent.stopPropagation();

    // Call the action handler defined in the items array
    handleOk(item.props, key);
  };

  return actionItems
    ?.filter((item) => item.isVisible)
    ?.map((item) => (
      <Tooltip key={item.key} title={item.label}>
        <Button
          shape="circle"
          icon={item.icon}
          type="text"
          disabled={item.disabled}
          onClick={() => handleOk(item, item.key)}
        />
      </Tooltip>
    ));
}
